import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import BackArrow from '@material-ui/icons/ArrowBackIos';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Link } from 'react-router-dom';
import LoadingIcon from '@material-ui/icons/Cached';
import PropTypes from 'prop-types';

import './RecentPages.css';
import { db, getUser, redirectToRoot } from '../../utilities/firebase-config';
import { formatTimeStamp } from '../../utilities/utils';
import styles from './RecentPages.style';

const PageRequestsList = ({ pageRequests }) => pageRequests.map(pageRequest => (
  <Link to={ `/page-status/${pageRequest.key}` } key={ pageRequest.key }>
    <ListItem button divider>
      <ListItemText
        primary={ `${formatTimeStamp(pageRequest.ts)} : ${pageRequest.senderName || ''}` }
        secondary={ pageRequest.message || '' }
      />
      <ListItemSecondaryAction>
        <IconButton aria-label="Details">
          <ChevronRightIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  </Link>
));

class RecentPages extends Component {
  state = {
    loading: true,
    pageRequests: [],
  };

  async componentDidMount() {
    const { history } = this.props;
    const user = await getUser();

    if (!user || !user.profile || user.profile.permissions !== 'Administrator') {
      redirectToRoot(history);
    }

    const dbRef = db.ref('pageRequests').orderByKey().limitToLast(20);
    dbRef.once('value', (snapshot) => {
      const data = snapshot.val();

      if (data) {
        const keys = Object.keys(data).reverse();
        const pageRequests = keys.map(key => ({
          key,
          message: data[key].message,
          senderName: data[key].senderName,
          ts: data[key].ts,
        }));

        this.setState({
          loading: false,
          pageRequests,
        });
      }
    });
  }

  goBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  render() {
    const { classes } = this.props;
    const { loading, pageRequests } = this.state;

    return (

      <div className="RecentPages container">

        <AppBar position="fixed" color="primary">
          <Toolbar>
            <IconButton className={ classes.menuButton } color="inherit" aria-label="Go Back" onClick={ this.goBack }>
              <BackArrow />
            </IconButton>
            <Typography variant="h6" color="inherit" className={ classes.grow }>
              Recent Pages
            </Typography>
          </Toolbar>
        </AppBar>

        {
          loading
          && <LoadingIcon className="loading-icon" />
        }

        <div className={ classes.root }>
          <List component="nav">
            <PageRequestsList pageRequests={ pageRequests } />
          </List>
        </div>
      </div>
    );
  }
}

RecentPages.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(RecentPages);
